import useMediaQuery from "hooks/useMediaQuery";
import React from "react";
import { MediaQueryConfig } from "utils/styles";

interface Props extends MediaQueryConfig {
  inverted?: boolean;
}

const Responsive: React.FC<Props> = ({
  inverted = false,
  children,
  ...mediaQueryConfig
}) => {
  const shouldRender = useMediaQuery(mediaQueryConfig);

  return shouldRender !== inverted ? <>{children}</> : null;
};

export default Responsive;
